import api from './api';
const searchService = {
  global: (params) => api.get('/search/global', { params }),
  vendors: (params) => api.get('/search/vendors', { params }),
  venues: (params) => api.get('/search/venues', { params }),
  suggestions: (q) => api.get('/search/suggestions', { params: { q } }),
  adminSearch: (q) => api.get('/admin/search', { params: { q } })
};
export default searchService;
